import {NgModule} from '@angular/core';

import {BaseTreeNodeComponent} from './index';
import {IonicModule} from 'ionic-angular';

/**
 * Module for the BaseTreeNodeModule
 * @class
 */
@NgModule({
  declarations: [BaseTreeNodeComponent],
  exports: [BaseTreeNodeComponent],
  imports: [IonicModule],
  providers: [],
})
export class BaseTreeNodeModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/components/tree/tree-node/base-tree-node/base-tree-node.component.module.ts